import TermsComp from "components/TermsComp";
import { useRouter } from "src/hooks/useRouter";

const TermsCompPage: React.FC = () => {
  const { goLogin } = useRouter();
  return (
    <>
      <div>
        <div className="top">
          {/* <a onClick={goLogin}>
            <div className="icon_fasoo main" />
          </a> */}
        </div>
      </div>
      <div style={{ width: "90%", margin: "auto" }}>
        <TermsComp></TermsComp>
      </div>
    </>
  );
};

export default TermsCompPage;
